<ng-template #illegal>
  <app-page403></app-page403>
</ng-template>


<card *ngIf="!illegalUser; else illegal">
   
  <mat-form-field appearance="fill" class='matwidth'>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker" [max]="maxDate" >
      <input matStartDate placeholder="Start date"  [(ngModel)]="dateRangeStart">
      <input matEndDate placeholder="End date"  [(ngModel)]="dateRangeEnd">
    </mat-date-range-input>
    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  <button class="btn-warning" style="display: flex;float: right;" (click)="clearSelectedDates()">Reset</button>
  <br>

  <button class="btn btn-primary" (click)='selectedDates()'
    [disabled]="!dateRangeStart || !dateRangeEnd">submit</button>

  <ng-container *ngIf="isLoading; else loadedBlock">
    <div>
      <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="200"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #loadedBlock>
    <div *ngIf="!displayErrorMessage; else error">
      <div class="col-md-12 my-5">
        <div *ngIf="auditAnalysisKeys.length > 0">
          <h3>Analysis Data</h3>
          <app-details [searchResults]="auditAnalysisKeys"></app-details>
        </div>
      </div>
    </div>
    <ng-template #error>
      <div class="error-box">{{errorMessage}}</div>
    </ng-template>
  </ng-template>

  <ng-template #noDataFound>
    <h3>No date found for {{ signedInUser.username }}</h3>
  </ng-template>
  <router-outlet name="print"></router-outlet>
</card>